module.exports = __webpack_public_path__ + "static/media/menuimage_tips.f4798c9b.jpg";